import { useEffect, useState, useRef } from "react";
import { getCookieName, getCookieValue } from "../app/functions/util";

const useWebSocket = () => {
    const [isConnected, setIsConnected] = useState(false);
    const [logData, setLogData] = useState([]);
    const [feed, setFeed] = useState([]);
    const [notes, setNotes] = useState([]);
    const [activities, setActivities] = useState([]);
    const [activityNote, setActivityNote] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [profileTasks, setProfileTasks] = useState([]);
    const [profile, setProfile] = useState(null);
    const [deals, setDeals] = useState([]);
    const [updateDealWithInhouseCampaign, setUpdateDealWithInhouseCampaign] = useState([]);
    const [deletedPotential, setDeletedPotential] = useState([]);

    const workerRef = useRef(null);

    // WebSocket bağlantı URL'ni oluştur
    const devUrl = "wss://dev.popleads.com/PopleadsDevCRM1/websocket";
    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0];
    const baseName = subdomain.includes("dev-crm-")
        ? `dev.popleads.com/PopleadsDevCRM${subdomain[subdomain.length - 1]}`
        : "secure.popleads.com/Xpider";
    const newUrl = hostname !== "localhost" ? `wss://${baseName}/websocket` : devUrl;

    useEffect(() => {
        const sid = getCookieValue(getCookieName());

        // Worker'ı başlat
        workerRef.current = new SharedWorker("/js/worker.js");

        // Worker'a mesaj gönder (bağlantıyı başlat)
        workerRef.current.port.start();
        workerRef.current.port.postMessage({ fn: "connect", url: newUrl });

        // Worker'dan gelen mesajları dinle
        workerRef.current.port.onmessage = (e) => {
            const data = e.data;
            // console.log("Worker message:", data);
            if (data.fn === "log") {
                // console.log("Worker log:", data.text);
                setLogData((prevLog) => [...prevLog, data.text]);
            } else if (data.fn === "init") {
                // İlk bağlantı sonrası oturum doğrulama gibi işlemler
                workerRef.current.port.postMessage({ fn: "cookieLogin", sid: sid });
            } else if (data.fn === "cookieLogin") {
                if (data.stat === "ok") {
                    // console.log("WebSocket connected:", data);
                    setIsConnected(true);
                }
            } else if (data.fn === "forceLogout") {
                window.location.reload();
            } else if (data.fn === "feed") {
                const newFeed = data.list.map((item) => item.note);
                setFeed((prevFeed) => [...prevFeed, ...newFeed]);
            } else if (data.fn === "activities") {
                const newActivities = data.activityList.map((item) => item.activity);
                setActivities(newActivities);
            } else if (data.fn === "activityNote") {
                const newActivityNote = data.list.map((item) => item.activityNote);
                setActivityNote((prevActivities) => [...prevActivities, ...newActivityNote]);
            } else if (data.fn === "tasks") {
                const newTasks = data.assignedTasks.map((item) => item.gorev);
                setTasks((prevTasks) => [...prevTasks, ...newTasks]);
            } else if (data.fn === "profileTasks") {
                const newTasks = data.tasks.map((item) => item.gorev);
                setProfileTasks((prevTasks) => [...prevTasks, ...newTasks]);
            } else if (data.fn === "profileNotes") {
                const newNotes = data.list.map((item) => item.note);
                setNotes((prevNotes) => [...prevNotes, ...newNotes]);
            } else if (data.fn === "profile") {
                setProfile(data.profile);
            } else if (data.fn === "olanakEkle") {
                const newDeal = data.list.map((item) => item.deal);
                setDeals((prevDeals) => [...prevDeals, ...newDeal]);
            } else if (data.fn === "updateDealWithInhouseCampaign") {
                const newDeal = data.list.map((item) => item.deal);
                setUpdateDealWithInhouseCampaign((prevDeals) => [...prevDeals, ...newDeal]);
            } else if (data.fn === "deletePotential") {
                const deletedDeal = data.list.map((item) => item.deal);
                setDeletedPotential((prevDeals) => [...prevDeals, ...deletedDeal]);
            }
        };

        window.addEventListener("beforeunload", () => {
            workerRef.current.port.postMessage({ fn: "close" });
        });

        return () => {
            // Component unmount olduğunda worker'ı kapat
            workerRef.current.port.postMessage({ fn: "close" });
            workerRef.current.port.close();
        };
    }, [newUrl]);

    return {
        isConnected,
        logData,
        feed,
        setFeed,
        notes,
        setNotes,
        activities,
        setActivities,
        activityNote,
        setActivityNote,
        tasks,
        setTasks,
        profileTasks,
        setProfileTasks,
        profile,
        setProfile,
        deals,
        setDeals,
        updateDealWithInhouseCampaign,
        setUpdateDealWithInhouseCampaign,
        deletedPotential,
        setDeletedPotential,
    };
};

export default useWebSocket;
